import React from "react"
import { Image } from "semantic-ui-react"

const FuelFeatureDetails = ({ feature, step }) => {
  return (
    <div className="fuel-feature-details">
      <p className="feature-step">{step}</p>
      <Image className="feature-image" src={feature.image} />
      <p className="feature-label">{feature.label}</p>
    </div>
  )
}

export default FuelFeatureDetails
